module.exports = __webpack_public_path__ + "static/media/camera.6a6f4b6e.svg";